<template>
  <div class="sponsorship">
    <!-- Editorial Hero -->
    <section class="ahrs-page-hero hero-photo-sponsorship">
      <div class="ahrs-page-hero-wrap">
        <div class="ahrs-page-eyebrow" data-aos="fade-up">
          <span class="dot"></span>Strategic Partnership
        </div>
        <h1 class="ahrs-page-title" data-aos="fade-up" data-aos-delay="100">
          Partner with
          <span class="ahrs-page-italic">Africa&rsquo;s HR community.</span>
        </h1>
        <p class="ahrs-page-lede" data-aos="fade-up" data-aos-delay="200">
          Join forces with AHRS to advance professional excellence, drive
          economic growth, and strengthen human capital development across
          the continent.
        </p>
      </div>
    </section>

    <!-- Impact Stats Section -->
    <section class="impact-stats-section" data-aos="fade-up">
      <div class="container-wide">
        <div class="stats-grid">
          <div class="stat-card" data-aos="zoom-in" data-aos-delay="100">
            <span class="stat-number">1,000+</span>
            <span class="stat-label">Active Members</span>
          </div>
          <div class="stat-card" data-aos="zoom-in" data-aos-delay="200">
            <span class="stat-number">20+</span>
            <span class="stat-label">Partner Organizations</span>
          </div>
          <div class="stat-card" data-aos="zoom-in" data-aos-delay="300">
            <span class="stat-number">5+</span>
            <span class="stat-label">Years of Excellence</span>
          </div>
          <div class="stat-card" data-aos="zoom-in" data-aos-delay="400">
            <span class="stat-number">50+</span>
            <span class="stat-label">Training Programs</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Why Partner Section -->
    <section class="why-partner-section" data-aos="fade-up">
      <div class="container-wide">
        <div class="section-header">
          <h2 class="section-title">Why Partner with AHRS</h2>
          <p class="section-subtitle">
            Gain strategic advantages while contributing to Tanzania's human capital development
          </p>
        </div>

        <div class="benefits-grid">
          <div class="benefit-card" data-aos="zoom-in" data-aos-delay="100">
            <i class="fas fa-star benefit-icon"></i>
            <h3 class="benefit-title">National Recognition</h3>
            <p class="benefit-description">
              Gain visibility across Tanzania's professional community and enhance your organization's reputation as a leader in human capital development.
            </p>
          </div>

          <div class="benefit-card" data-aos="zoom-in" data-aos-delay="200">
            <i class="fas fa-bullseye benefit-icon"></i>
            <h3 class="benefit-title">Strategic Alignment</h3>
            <p class="benefit-description">
              Align your corporate social responsibility initiatives with Tanzania's national development priorities and Vision 2025 goals.
            </p>
          </div>

          <div class="benefit-card" data-aos="zoom-in" data-aos-delay="300">
            <i class="fas fa-handshake benefit-icon"></i>
            <h3 class="benefit-title">Meaningful Impact</h3>
            <p class="benefit-description">
              Contribute directly to capacity building initiatives that strengthen Tanzania's workforce and drive economic transformation.
            </p>
          </div>

          <div class="benefit-card" data-aos="zoom-in" data-aos-delay="400">
            <i class="fas fa-chart-bar benefit-icon"></i>
            <h3 class="benefit-title">Market Access</h3>
            <p class="benefit-description">
              Connect with key decision-makers across public and private sectors, expanding your network and business opportunities.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Sponsorship Packages Section -->
    <section class="packages-section" data-aos="fade-up">
      <div class="container-wide">
        <div class="section-header">
          <h2 class="section-title">Strategic Sponsorship Investment Opportunities</h2>
          <p class="section-subtitle">
            Comprehensive sponsorship packages designed to provide maximum value and impact for organizations seeking to support Tanzania's human resource development
          </p>
        </div>

        <div class="packages-grid">
          <!-- Platinum Sponsor -->
          <div class="package-card premium" data-aos="zoom-in" data-aos-delay="100">
            <div class="package-header">
              <div class="package-badge">⭐ RECOMMENDED</div>
              <h3 class="package-title">Platinum Sponsor</h3>
              <div class="package-price">USD 40,000</div>
            </div>
            <div class="package-content">
              <div class="benefits-section">
                <h4><i class="fas fa-bullseye"></i> Wide Publicity & Recognition</h4>
                <ul>
                  <li>Wide publicity of the organization's name and logo</li>
                  <li>Mentioned as the main sponsor of the event</li>
                  <li>Special offer for the MD/CEO to address the audience</li>
                  <li>Event brochures advertisement</li>
                  <li>Press advertisements</li>
                  <li>THRAPA website coverage</li>
                  <li>Covered in promotional material</li>
                  <li>Displaying banners unlimited</li>
                  <li>Displaying in e-Newsletter</li>
                  <li>Mentioning the sponsor</li>
                </ul>
              </div>
              <div class="benefits-section">
                <h4><i class="fas fa-handshake"></i> Promotion & Engagement</h4>
                <ul>
                  <li>Promotion and exhibition booth</li>
                  <li>Complimentary registration for four representatives</li>
                  <li>Acknowledgment and Awards</li>
                </ul>
              </div>
            </div>
            <button class="package-button" @click="selectPackage('platinum')">
              Choose Platinum
            </button>
          </div>

          <!-- Diamond Sponsor -->
          <div class="package-card" data-aos="zoom-in" data-aos-delay="200">
            <div class="package-header">
              <h3 class="package-title">Diamond Sponsor</h3>
              <div class="package-price">USD 20,000</div>
            </div>
            <div class="package-content">
              <div class="benefits-section">
                <h4><i class="fas fa-bullseye"></i> Wide Publicity & Recognition</h4>
                <ul>
                  <li>Wide publicity of the organization's name and logo</li>
                  <li>Brochures advertisement</li>
                  <li>Press advertisement</li>
                  <li>THRAPA website coverage</li>
                  <li>Covered in promotional material</li>
                  <li>Displaying four banners</li>
                  <li>Mentioning the sponsor</li>
                </ul>
              </div>
              <div class="benefits-section">
                <h4><i class="fas fa-handshake"></i> Promotion & Engagement</h4>
                <ul>
                  <li>Promotion and exhibition booth</li>
                  <li>Complimentary registration for three representatives</li>
                  <li>Acknowledgment and Awards</li>
                </ul>
              </div>
            </div>
            <button class="package-button" @click="selectPackage('diamond')">
              Choose Diamond
            </button>
          </div>

          <!-- Gold Sponsor -->
          <div class="package-card" data-aos="zoom-in" data-aos-delay="300">
            <div class="package-header">
              <h3 class="package-title">Gold Sponsor</h3>
              <div class="package-price">USD 10,000</div>
            </div>
            <div class="package-content">
              <div class="benefits-section">
                <h4><i class="fas fa-bullseye"></i> Wide Publicity & Recognition</h4>
                <ul>
                  <li>Wide publicity of the organization's name and logo</li>
                  <li>Brochures advertisement</li>
                  <li>Displaying three banners</li>
                  <li>Mentioning the sponsor</li>
                </ul>
              </div>
              <div class="benefits-section">
                <h4><i class="fas fa-handshake"></i> Promotion & Engagement</h4>
                <ul>
                  <li>Promotion and exhibition booth</li>
                  <li>Complimentary registration for two representatives</li>
                  <li>Acknowledgment and Awards</li>
                </ul>
              </div>
            </div>
            <button class="package-button" @click="selectPackage('gold')">
              Choose Gold
            </button>
          </div>

          <!-- Silver Sponsor -->
          <div class="package-card" data-aos="zoom-in" data-aos-delay="400">
            <div class="package-header">
              <h3 class="package-title">Silver Sponsor</h3>
              <div class="package-price">USD 5,000</div>
            </div>
            <div class="package-content">
              <div class="benefits-section">
                <h4><i class="fas fa-bullseye"></i> Wide Publicity & Recognition</h4>
                <ul>
                  <li>Wide publicity of the organization's name and logo</li>
                  <li>Brochures advertisement</li>
                  <li>Mentioning sponsor</li>
                  <li>Display two banners</li>
                </ul>
              </div>
              <div class="benefits-section">
                <h4><i class="fas fa-handshake"></i> Promotion & Engagement</h4>
                <ul>
                  <li>Promotion and Exhibition booth</li>
                  <li>Acknowledgment and Awards</li>
                </ul>
              </div>
            </div>
            <button class="package-button" @click="selectPackage('silver')">
              Choose Silver
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Application Form Section -->
    <section class="application-form-section" data-aos="fade-up" id="application-form">
      <div class="container-wide">
        <div class="form-header">
          <h2 class="section-title">Apply for Sponsorship</h2>
          <p class="section-subtitle">
            Join Africa's leading organizations in supporting professional excellence and Continental development through strategic partnership with AHRS.
          </p>
        </div>

        <div class="form-container">
          <!-- Step Progress Indicator -->
          <div class="progress-indicator" v-if="!formSubmitted">
            <div class="step" :class="{ active: currentStep === 1, completed: currentStep > 1 }">
              <div class="step-number"><i class="fas fa-user"></i></div>
              <div class="step-label">Contact Information</div>
            </div>
            <div class="progress-line" :class="{ active: currentStep > 1 }"></div>
            <div class="step" :class="{ active: currentStep === 2, completed: formSubmitted }">
              <div class="step-number"><i class="fas fa-handshake"></i></div>
              <div class="step-label">Sponsorship Details</div>
            </div>
          </div>

          <!-- Success Message -->
          <div v-if="formSubmitted" class="success-message" data-aos="zoom-in">
            <div class="success-icon"><i class="fas fa-check"></i></div>
            <h3>Application Submitted Successfully!</h3>
            <p>Thank you for your interest in sponsoring AHRS. Our partnerships team will review your application and contact you within 48 hours.</p>
            <div class="success-actions">
              <button class="btn-secondary" @click="resetForm">Submit Another Application</button>
              <router-link to="/strategic-partnership" class="btn-primary">
                View Partnership Information
              </router-link>
            </div>
          </div>

          <!-- Application Form -->
          <form v-if="!formSubmitted" @submit.prevent="handleSubmit" class="sponsorship-form">
            <!-- Step 1: Contact Information -->
            <div v-if="currentStep === 1" class="form-step" data-aos="fade-in">
              <h3 class="step-title">Contact Information</h3>

              <div class="form-grid">
                <div class="form-group">
                  <label for="firstName">First Name *</label>
                  <input
                    type="text"
                    id="firstName"
                    v-model="formData.firstName"
                    required
                    :class="{ error: errors.firstName }"
                  >
                  <span v-if="errors.firstName" class="error-message">{{ errors.firstName }}</span>
                </div>

                <div class="form-group">
                  <label for="lastName">Last Name *</label>
                  <input
                    type="text"
                    id="lastName"
                    v-model="formData.lastName"
                    required
                    :class="{ error: errors.lastName }"
                  >
                  <span v-if="errors.lastName" class="error-message">{{ errors.lastName }}</span>
                </div>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label for="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    v-model="formData.email"
                    required
                    placeholder="your.email@company.com"
                    :class="{ error: errors.email }"
                  >
                  <span v-if="errors.email" class="error-message">{{ errors.email }}</span>
                </div>

                <div class="form-group">
                  <label for="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    v-model="formData.phone"
                    required
                    placeholder="+255 123 456 789"
                    :class="{ error: errors.phone }"
                  >
                  <span v-if="errors.phone" class="error-message">{{ errors.phone }}</span>
                </div>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label for="country">Country *</label>
                  <select
                    id="country"
                    v-model="formData.country"
                    required
                    :class="{ error: errors.country }"
                  >
                    <option value="">Select Country</option>
                    <option value="TZ">Tanzania</option>
                    <option value="KE">Kenya</option>
                    <option value="UG">Uganda</option>
                    <option value="RW">Rwanda</option>
                    <option value="BI">Burundi</option>
                    <option value="ZA">South Africa</option>
                    <option value="NG">Nigeria</option>
                    <option value="GH">Ghana</option>
                    <option value="US">United States</option>
                    <option value="GB">United Kingdom</option>
                    <option value="DE">Germany</option>
                    <option value="FR">France</option>
                    <option value="CA">Canada</option>
                    <option value="AU">Australia</option>
                    <option value="OTHER">Other</option>
                  </select>
                  <span v-if="errors.country" class="error-message">{{ errors.country }}</span>
                </div>

                <div class="form-group">
                  <label for="position">Your Position *</label>
                  <input
                    type="text"
                    id="position"
                    v-model="formData.position"
                    required
                    placeholder="CEO, Marketing Director, etc."
                    :class="{ error: errors.position }"
                  >
                  <span v-if="errors.position" class="error-message">{{ errors.position }}</span>
                </div>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label for="company">Company Name *</label>
                  <input
                    type="text"
                    id="company"
                    v-model="formData.company"
                    required
                    :class="{ error: errors.company }"
                  >
                  <span v-if="errors.company" class="error-message">{{ errors.company }}</span>
                </div>

                <div class="form-group">
                  <label for="website">Company Website</label>
                  <input
                    type="url"
                    id="website"
                    v-model="formData.website"
                    placeholder="https://www.yourcompany.com"
                  >
                </div>
              </div>

              <div class="form-group">
                <label for="companyDescription">Company Description *</label>
                <textarea
                  id="companyDescription"
                  v-model="formData.companyDescription"
                  required
                  rows="4"
                  placeholder="Brief description of your company and what you do"
                  :class="{ error: errors.companyDescription }"
                ></textarea>
                <span v-if="errors.companyDescription" class="error-message">{{ errors.companyDescription }}</span>
              </div>

              <div class="form-actions">
                <button type="button" class="btn-primary" @click="nextStep" :disabled="!isStep1Valid">
                  Next Step
                </button>
              </div>
            </div>

            <!-- Step 2: Sponsorship Details -->
            <div v-if="currentStep === 2" class="form-step" data-aos="fade-in">
              <h3 class="step-title">Sponsorship Details</h3>

              <div class="form-group">
                <label>Sponsorship Level *</label>
                <div class="radio-group">
                  <div class="radio-item">
                    <input
                      type="radio"
                      id="platinum"
                      value="platinum"
                      v-model="formData.sponsorshipLevel"
                    >
                    <label for="platinum">Platinum Sponsor (USD 30,000)</label>
                  </div>
                  <div class="radio-item">
                    <input
                      type="radio"
                      id="diamond"
                      value="diamond"
                      v-model="formData.sponsorshipLevel"
                    >
                    <label for="diamond">Diamond Sponsor (USD 20,000)</label>
                  </div>
                  <div class="radio-item">
                    <input
                      type="radio"
                      id="gold"
                      value="gold"
                      v-model="formData.sponsorshipLevel"
                    >
                    <label for="gold">Gold Sponsor (USD 10,000)</label>
                  </div>
                  <div class="radio-item">
                    <input
                      type="radio"
                      id="silver"
                      value="silver"
                      v-model="formData.sponsorshipLevel"
                    >
                    <label for="silver">Silver Sponsor (USD 5,000)</label>
                  </div>
                </div>
                <span v-if="errors.sponsorshipLevel" class="error-message">{{ errors.sponsorshipLevel }}</span>
              </div>

              <div class="form-group">
                <label>Communication Preference *</label>
                <div class="radio-group">
                  <div class="radio-item">
                    <input
                      type="radio"
                      id="email-pref"
                      value="email"
                      v-model="formData.communicationPreference"
                    >
                    <label for="email-pref">Email</label>
                  </div>
                  <div class="radio-item">
                    <input
                      type="radio"
                      id="phone-pref"
                      value="phone"
                      v-model="formData.communicationPreference"
                    >
                    <label for="phone-pref">Phone</label>
                  </div>
                  <div class="radio-item">
                    <input
                      type="radio"
                      id="both-pref"
                      value="both"
                      v-model="formData.communicationPreference"
                    >
                    <label for="both-pref">Both</label>
                  </div>
                </div>
                <span v-if="errors.communicationPreference" class="error-message">{{ errors.communicationPreference }}</span>
              </div>

              <div class="form-group">
                <label for="specificRequirements">Specific Requirements or Preferences</label>
                <textarea
                  id="specificRequirements"
                  v-model="formData.specificRequirements"
                  rows="3"
                  placeholder="Any specific requirements or preferences for your sponsorship package"
                ></textarea>
              </div>

              <div class="form-group">
                <label for="estimatedBudget">Estimated Budget for Sponsorship (TZS)</label>
                <input
                  type="text"
                  id="estimatedBudget"
                  v-model="formattedBudget"
                  @input="formatBudget"
                  placeholder="10,000,000"
                >
              </div>

              <div class="form-group">
                <label for="additionalComments">Additional Comments or Questions</label>
                <textarea
                  id="additionalComments"
                  v-model="formData.additionalComments"
                  rows="4"
                  placeholder="Any additional comments or questions"
                ></textarea>
              </div>

              <div class="form-actions">
                <button type="button" class="btn-secondary" @click="previousStep">
                  Previous
                </button>
                <button type="submit" class="btn-primary" :disabled="!isStep2Valid || isSubmitting">
                  <span v-if="isSubmitting">Submitting...</span>
                  <span v-else>Submit Application</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section class="contact-section" data-aos="fade-up">
      <div class="container-wide">
        <div class="contact-content">
          <div class="contact-info">
            <h2>Partnership & Sponsorship Department</h2>
            <p>For partnership inquiries and sponsorship opportunities:</p>

            <div class="contact-details">
              <div class="contact-item">
                <span class="contact-label">Email:</span>
                <a href="mailto:sponsorship@africahrsummit.org" class="contact-link">sponsorship@africahrsummit.org</a>
              </div>
              <div class="contact-item">
                <span class="contact-label">Phone:</span>
                <a href="tel:+255745004005" class="contact-link">+255 745 004 005</a>
              </div>
              <!-- <div class="contact-item">
                <span class="contact-label">Address:</span>
                <span class="contact-value">THRAPA Headquarters, Dodoma, Tanzania</span>
              </div> -->
            </div>

            <div class="partnership-director">
              <h3>Partnership Director</h3>
              <div class="director-info">
                <div class="director-name">Grace Nzula</div>
                <div class="director-title">Director of Corporate Sercices </div>
                <div class="director-contacts">
                  <a href="mailto:sophia.weinand@africahrsummit.org" class="contact-link">grace.nzula@africahrsummit.org</a>
                  <a href="tel:+254721442223" class="contact-link">+254 721 442 223</a>
                </div>
              </div>
            </div>
          </div>

          <div class="cta-section">
            <h3>Ready to Make an Impact?</h3>
            <p>Join Tanzania's leading organizations in supporting professional excellence and national development.</p>
            <div class="cta-buttons">
              <button class="cta-button primary" @click="scrollToForm">
                Apply for Sponsorship
              </button>
              <router-link to="/strategic-partnership" class="cta-button secondary">
                View Partnerships
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { theme } from '@/theme';

export default {
  name: 'SponsorshipView',
  setup() {
    const currentStep = ref(1);
    const isSubmitting = ref(false);
    const formSubmitted = ref(false);
    const errors = ref({});

    const formData = ref({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      country: '',
      company: '',
      website: '',
      position: '',
      companyDescription: '',
      sponsorshipLevel: '',
      communicationPreference: '',
      specificRequirements: '',
      estimatedBudget: '',
      additionalComments: ''
    });

    const formattedBudget = ref('');

    const selectPackage = (packageType) => {
      formData.value.sponsorshipLevel = packageType;
      scrollToForm();
    };

    const scrollToForm = () => {
      const formElement = document.getElementById('application-form');
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth' });
      }
    };

    const isStep1Valid = computed(() => {
      return formData.value.firstName &&
             formData.value.lastName &&
             formData.value.email &&
             formData.value.phone &&
             formData.value.country &&
             formData.value.company &&
             formData.value.position &&
             formData.value.companyDescription;
    });

    const isStep2Valid = computed(() => {
      return formData.value.sponsorshipLevel &&
             formData.value.communicationPreference;
    });

    const nextStep = () => {
      validateStep1();
      if (isStep1Valid.value) {
        currentStep.value = 2;
      }
    };

    const previousStep = () => {
      currentStep.value = 1;
    };

    const validateStep1 = () => {
      errors.value = {};

      if (!formData.value.firstName) errors.value.firstName = 'First name is required';
      if (!formData.value.lastName) errors.value.lastName = 'Last name is required';
      if (!formData.value.email) errors.value.email = 'Email is required';
      else if (!/\S+@\S+\.\S+/.test(formData.value.email)) errors.value.email = 'Invalid email format';
      if (!formData.value.phone) errors.value.phone = 'Phone number is required';
      if (!formData.value.country) errors.value.country = 'Country is required';
      if (!formData.value.company) errors.value.company = 'Company name is required';
      if (!formData.value.position) errors.value.position = 'Position is required';
      if (!formData.value.companyDescription) errors.value.companyDescription = 'Company description is required';
    };

    const validateStep2 = () => {
      if (!formData.value.sponsorshipLevel) errors.value.sponsorshipLevel = 'Sponsorship level is required';
      if (!formData.value.communicationPreference) errors.value.communicationPreference = 'Communication preference is required';
    };

    const formatBudget = (event) => {
      let value = event.target.value.replace(/,/g, '');
      if (!isNaN(value) && value !== '') {
        formattedBudget.value = parseInt(value).toLocaleString();
        formData.value.estimatedBudget = value;
      } else {
        formattedBudget.value = '';
        formData.value.estimatedBudget = '';
      }
    };

    const handleSubmit = async () => {
      validateStep2();

      if (!isStep2Valid.value) {
        return;
      }

      isSubmitting.value = true;

      try {
        // Simulate API call
        await new Promise(resolve => setTimeout(resolve, 2000));

        // Here you would typically send the form data to your backend
        console.log('Form submitted:', formData.value);

        formSubmitted.value = true;
      } catch (error) {
        console.error('Submission error:', error);
        // Handle error - show error message to user
      } finally {
        isSubmitting.value = false;
      }
    };

    const resetForm = () => {
      formData.value = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        country: '',
        company: '',
        website: '',
        position: '',
        companyDescription: '',
        sponsorshipLevel: '',
        communicationPreference: '',
        specificRequirements: '',
        estimatedBudget: '',
        additionalComments: ''
      };
      formattedBudget.value = '';
      currentStep.value = 1;
      formSubmitted.value = false;
      errors.value = {};
    };

    onMounted(() => {
      // Initialize AOS if available
      if (window.AOS) {
        window.AOS.init({
          duration: 1000,
          easing: 'ease-in-out-quart',
          once: true
        });
      }
    });

    return {
      currentStep,
      isSubmitting,
      formSubmitted,
      errors,
      formData,
      formattedBudget,
      isStep1Valid,
      isStep2Valid,
      selectPackage,
      scrollToForm,
      nextStep,
      previousStep,
      formatBudget,
      handleSubmit,
      resetForm,
      theme
    };
  }
};
</script>

<style scoped>
/* Editorial hero backdrop photo */
.hero-photo-sponsorship {
  --hero-photo: url("~@/assets/images/past Ahrs/award.jpg");
}

/* Hero Section */
.hero-section {
  position: relative;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--gradient-hero);
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 71, 42, 0.1);
}

.floating-shapes {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.shape {
  position: absolute;
  background: rgba(74, 222, 128, 0.1);
  border-radius: 50%;
}

.shape-1 {
  width: 300px;
  height: 300px;
  top: 10%;
  left: -150px;
  animation: float 12s ease-in-out infinite;
}

.shape-2 {
  width: 200px;
  height: 200px;
  top: 50%;
  right: -100px;
  animation: float 8s ease-in-out infinite reverse;
}

.shape-3 {
  width: 150px;
  height: 150px;
  top: 30%;
  left: 70%;
  animation: float 10s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-40px) rotate(180deg); }
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.government-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 2rem;
  font-weight: 600;
  font-size: 1rem;
}

.badge-icon {
  font-size: 1.2rem;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.1;
}

.hero-subtitle {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  opacity: 0.95;
  line-height: 1.6;
}

.partnership-badges {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.badge {
  background: rgba(74, 222, 128, 0.2);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  font-size: 0.9rem;
  font-weight: 500;
}

/* Impact Stats Section */
.impact-stats-section {
  padding: 3rem 0;
  background: var(--color-white);
  margin-top: -2rem;
  position: relative;
  z-index: 3;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
}

.stat-card {
  text-align: center;
  padding: 2rem 1rem;
  background: var(--color-background-light);
  border-radius: 1rem;
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
}

.stat-number {
  display: block;
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--color-primary);
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Why Partner Section */
.why-partner-section {
  padding: 5rem 0;
  background: var(--color-background-light);
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 600;
  color: var(--color-primary-dark);
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: var(--color-text-secondary);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.benefit-card {
  background: var(--color-white);
  padding: 2.5rem 2rem;
  border-radius: 1rem;
  box-shadow: var(--shadow-md);
  text-align: center;
  transition: all 0.3s ease;
}

.benefit-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-xl);
}

.benefit-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  display: block;
}

.benefit-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--color-primary-dark);
  margin-bottom: 1rem;
}

.benefit-description {
  color: var(--color-text-secondary);
  line-height: 1.6;
}

/* Packages Section */
.packages-section {
  padding: 5rem 0;
  background: var(--color-white);
}

.packages-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  margin-top: 3rem;
}

.package-card {
  background: var(--color-white);
  border-radius: 1rem;
  box-shadow: var(--shadow-lg);
  border: 2px solid var(--color-background-light);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.package-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-xl);
  border-color: var(--color-accent);
}

.package-card.premium {
  border: 2px solid var(--color-accent);
  transform: scale(1.05);
  position: relative;
}

.package-card.premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--gradient-cta);
}

.package-header {
  padding: 2rem 2rem 1rem;
  text-align: center;
  position: relative;
}

.package-badge {
  position: absolute;
  top: -1rem;
  left: 50%;
  transform: translateX(-50%);
  background: var(--gradient-cta);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
}

.package-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--color-primary-dark);
  margin-bottom: 0.5rem;
}

.package-price {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--color-primary);
  margin-bottom: 1rem;
}

.package-content {
  padding: 0 2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.benefits-section {
  margin-bottom: 2rem;
}

.benefits-section h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-primary-dark);
  margin-bottom: 1rem;
}

.benefits-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.benefits-section li {
  padding: 0.4rem 0;
  color: var(--color-text-secondary);
  position: relative;
  padding-left: 1.5rem;
}

.benefits-section li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--color-primary);
  font-weight: bold;
}

.package-button {
  background: var(--gradient-cta);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 2rem;
  margin-top: auto;
}

.package-button:hover {
  background: var(--gradient-hover);
  transform: translateY(-2px);
}

/* Application Form Section */
.application-form-section {
  padding: 5rem 0;
  background: var(--gradient-section);
}

.form-header {
  text-align: center;
  margin-bottom: 3rem;
}

.form-container {
  max-width: 800px;
  margin: 0 auto;
  background: var(--color-white);
  border-radius: 1rem;
  box-shadow: var(--shadow-xl);
  overflow: hidden;
}

.progress-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: var(--color-background-light);
  border-bottom: 1px solid var(--color-background);
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.step.active,
.step.completed {
  opacity: 1;
}

.step-number {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--color-background);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  transition: all 0.3s ease;
}

.step.active .step-number,
.step.completed .step-number {
  background: var(--gradient-cta);
  color: white;
}

.step-label {
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.progress-line {
  width: 100px;
  height: 2px;
  background: var(--color-background);
  margin: 0 2rem;
  transition: background 0.3s ease;
}

.progress-line.active {
  background: var(--gradient-cta);
}

.sponsorship-form {
  padding: 2rem;
}

.form-step {
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateX(20px); }
  to { opacity: 1; transform: translateX(0); }
}

.step-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-primary-dark);
  margin-bottom: 2rem;
  text-align: center;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 600;
  color: var(--color-primary-dark);
  font-size: 0.9rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 1rem;
  border: 2px solid var(--color-background);
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(34, 139, 34, 0.1);
}

.form-group input.error,
.form-group select.error,
.form-group textarea.error {
  border-color: var(--color-error);
}

.error-message {
  color: var(--color-error);
  font-size: 0.8rem;
  font-weight: 500;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-top: 0.5rem;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.radio-item input[type="radio"] {
  width: 18px;
  height: 18px;
  margin: 0;
}

.radio-item label {
  margin: 0;
  cursor: pointer;
  font-weight: 500;
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--color-background);
}

.btn-primary,
.btn-secondary {
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  font-size: 1rem;
  min-width: 150px;
}

.btn-primary {
  background: var(--gradient-cta);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: var(--gradient-hover);
  transform: translateY(-2px);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.btn-secondary {
  background: white;
  color: var(--color-primary);
  border: 2px solid var(--color-primary);
}

.btn-secondary:hover {
  background: var(--color-primary);
  color: white;
}

/* Success Message */
.success-message {
  text-align: center;
  padding: 4rem 2rem;
}

.success-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: var(--color-success);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  margin: 0 auto 2rem;
  animation: successPulse 2s ease-in-out;
}

@keyframes successPulse {
  0% { transform: scale(0); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.success-message h3 {
  font-size: 1.8rem;
  color: var(--color-primary-dark);
  margin-bottom: 1rem;
}

.success-message p {
  color: var(--color-text-secondary);
  margin-bottom: 2rem;
  line-height: 1.6;
}

.success-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

/* Contact Section */
.contact-section {
  background: var(--gradient-primary);
  color: white;
  padding: 5rem 0;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;
}

.contact-info h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: white;
}

.contact-info p {
  margin-bottom: 2rem;
  opacity: 0.9;
  line-height: 1.6;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 3rem;
}

.contact-item {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.contact-label {
  font-weight: 600;
  min-width: 80px;
  opacity: 0.9;
}

.contact-value,
.contact-link {
  color: var(--color-accent);
  font-weight: 500;
  text-decoration: none;
}

.contact-link:hover {
  text-decoration: underline;
}

.partnership-director {
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  backdrop-filter: blur(10px);
}

.partnership-director h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: white;
}

.director-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-accent);
  margin-bottom: 0.5rem;
}

.director-title {
  font-size: 0.9rem;
  opacity: 0.9;
  margin-bottom: 1rem;
}

.director-contacts {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.cta-section {
  text-align: center;
}

.cta-section h3 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: white;
}

.cta-section p {
  margin-bottom: 2rem;
  opacity: 0.9;
  line-height: 1.6;
}

.cta-buttons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cta-button {
  display: inline-block;
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  font-size: 1rem;
}

.cta-button.primary {
  background: var(--gradient-cta);
  color: white;
}

.cta-button.secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.cta-button:hover {
  transform: translateY(-2px);
  text-decoration: none;
}

.cta-button.primary:hover {
  color: white;
}

.cta-button.secondary:hover {
  background: white;
  color: var(--color-primary);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .packages-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
}

@media (max-width: 900px) {
  .packages-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .package-card.premium {
    transform: none;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
  }

  .partnership-badges {
    flex-direction: column;
    gap: 0.5rem;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .benefits-grid {
    grid-template-columns: 1fr;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .contact-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .form-actions {
    flex-direction: column;
  }

  .progress-indicator {
    padding: 1rem;
  }

  .step {
    flex: 1;
  }

  .progress-line {
    margin: 0 1rem;
  }

  .success-actions {
    flex-direction: column;
  }

  .cta-buttons {
    gap: 0.8rem;
  }
}

@media (max-width: 480px) {
  .hero-content {
    padding: 1rem;
  }

  .hero-title {
    font-size: 2rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .partnership-director {
    padding: 1.5rem;
  }

  .contact-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .contact-label {
    min-width: auto;
    font-size: 0.9rem;
  }

  .progress-indicator {
    flex-direction: column;
    gap: 1rem;
  }

  .progress-line {
    width: 2px;
    height: 50px;
    margin: 0;
  }

  .step {
    flex-direction: row;
    gap: 1rem;
  }
}
</style>